// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"p3-z","colorTextValue":"q3-z","swatches":"r3-z","collapseLink":"s3-z","isCollapsed":"t3-z","dropdown":"u3-z","disabled":"v3-z"};